<template>
  <div class="stepper">
    <div v-for="step in steps" :key="step?.step_id">
      <component :is="forms[step?.view_component as keyof object]" v-if="step?.step_id === props.currentStep?.step_id" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ODynamicForm from '@/components/organisms/forms/O-DynamicForm.vue'
import type { Component } from 'vue'
import type { OStepperProps } from './o-stepper-props'

const props = defineProps<OStepperProps>()

const forms: Record<string, Component> = {
  ODynamicForm
}
</script>
